import React from "react"
import { Helmet } from "react-helmet-async"

export default function SEO({
  title = "Centre Spa Land Vincci Saphir Palace | Spa de Luxe à Hammamet",
  description = "Découvrez le Centre Spa Land Vincci Saphir Palace à Hammamet : massages relaxants, hammam traditionnel, soins du visage, beauté, piscine intérieure chauffée et espace fitness dans un cadre luxueux.",
  keywords = "spa Hammamet, spa Tunisie, massage Hammamet, hammam traditionnel, soins du visage, beauté, bien-être, piscine intérieure, fitness, Vincci Saphir Palace",
  image = "https://www.spalandvinccisaphirpalace.com/images/hero.jpg",
  url = "https://www.spalandvinccisaphirpalace.com",
  type = "website",
}) {
  return (
    <Helmet>
      {/* SEO de base */}
      <title>{title}</title>

      <meta
        name="description"
        content={description}
      />

      <meta
        name="keywords"
        content={keywords}
      />

      <meta
        name="robots"
        content="index, follow"
      />

      <meta
        name="author"
        content="Centre Spa Land Vincci Saphir Palace"
      />

      <meta
        name="viewport"
        content="width=device-width, initial-scale=1"
      />

      {/* Open Graph */}
      <meta
        property="og:type"
        content={type}
      />

      <meta
        property="og:title"
        content={title}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:image"
        content={image}
      />

      <meta
        property="og:url"
        content={url}
      />

      <meta
        property="og:site_name"
        content="Centre Spa Land Vincci Saphir Palace"
      />

      <meta
        property="og:locale"
        content="fr_FR"
      />

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={title}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={image}
      />

      {/* URL canonique */}
      <link
        rel="canonical"
        href={url}
      />

      {/* Couleur du navigateur */}
      <meta
        name="theme-color"
        content="#b8955d"
      />
    </Helmet>
  )
}